import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate";
import { GroundHeader } from "components/PurpleHeader/GroundHeader";
import React from "react";
import { useGroundTransportDetail } from "./useGroundTransportDetail";
import { groundTransportSections } from "./groundTransportSections";
import { getGroundFieldMetaData } from "shared/utils/fieldsHelper/groundFields";
import { LinkedShowSimplePanel } from "document/linkshow/LinkedShowSimplePanel";
import { type LinkShowToTravelConfig } from "components/LinkShowToTravelButton";

interface Props {
  groundTransport: server.dto.GroundTransport
  linkedShows: server.dto.LinkedShow[]
  linkShowToTravel: LinkShowToTravelConfig
  passengers: server.dto.ContactSmallV2[]
  onUpdated: () => Promise<void>
}

export const GroundTransportDetailSection = (props: Props) => {
  const {
    state,
    hasDriver,
    hasMap,
    onValueChanged,
    onSuccessfulUpdate,
    getUpdateGroundTransportInstruction,
  } = useGroundTransportDetail(
    props.groundTransport,
    props.passengers,
  );

  const onSuccessfulUpdateAndRefresh = async (key: string, value: any) => {
    await onSuccessfulUpdate(key, value);
    await props.onUpdated();
  }

  const fieldMetaData = getGroundFieldMetaData(site.currentEnvironment, state, props.groundTransport.permissions);

  return <DetailSectionTemplate
    header={<GroundHeader groundTransport={props.groundTransport} passengers={props.passengers} />}
    isInPageEditable={props.groundTransport.permissions.canModify}
    onValueChanged={onValueChanged}
    onSuccessfulUpdate={onSuccessfulUpdateAndRefresh}
    sections={[
      ...groundTransportSections(state, fieldMetaData, getUpdateGroundTransportInstruction, hasDriver, hasMap),
      {
        key: "linkedShows",
        type: "custom",
        render: () => <LinkedShowSimplePanel
          key="linkedShows"
          linkedShows={props.linkedShows}
          linkShowToTravel={props.linkShowToTravel}
        />
      }
    ]}
  />
}
